import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { adminMe, adminLogin, getAdminToken, setAdminToken } from "../lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getAdminToken()) {
      setMe(null);
      setLoading(false);
      return null;
    }
    try {
      const data = await adminMe();
      setMe(data);
      return data;
    } catch (_e) {
      setAdminToken("");
      setMe(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async ({ email, password }) => {
    const data = await adminLogin({ email, password });
    await refresh();
    return data;
  };

  const logout = () => {
    setAdminToken("");
    setMe(null);
  };

  const value = useMemo(() => ({ me, loading, login, logout, refresh }), [me, loading, refresh]);
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return ctx;
}
